import { useParams } from 'react-router'
import { Heading } from '@/components/base/heading'
// @ts-expect-error fragment is used in the query by fragment name
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ItemTypeConnectorFamilies, ItemTypeConnectorFamiliesFragment } from '@/components/item_types/connector_families'
import { graphql } from '@/gql'
import { useQuery } from '@apollo/client/react'
import { Slimline as Error } from '@/components/error'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { Button } from '@/components/base/button'

export const ItemTypeConnectorFamiliesQuery = graphql(`
  query ItemTypeConnectorFamilies($id: ID!) {
    itemTypes(filters: { idEq: $id }) {
      nodes {
        id
        name
        ...ItemTypeConnectorFamiliesDetail
      }
    }
  }
`)

export const ConnectorFamilies = () => {
  const { id } = useParams() as { id: string }

  const { data, loading, error } = useQuery(ItemTypeConnectorFamiliesQuery, { variables: { id } })

  if (loading) return <LoadingSkeleton table title />

  return (<div className="flex flex-col gap-3 grow">
    { error && <Error error={ error } /> }
    { data && <>
      <div className="flex flex-row justify-between items-center">
        <Heading level={ 1 } size="3xl">Connectors for { data.itemTypes.nodes[0].name }</Heading>
        <Button color="purple" href={ `/item_types/${id}` }>Back</Button>
      </div>
      <ItemTypeConnectorFamilies id={ id } />
    </> }
  </div>)
}
